t = require('views/internal/teacup-with-helpers')('tip_help')
View = require 'view'
template = require 'views/templates/header_info_help_menu'
track = require 'debug/track'

tips = [
  {
    title: t.l 'board-basics'
    description: t.l 'board-basics-description'
    buttonText: t.l 'tell-me-more'
    url: '/guide/board-basics'
    imgUrl1x: require 'images/tips/board-basics@1x.png'
    imgUrl2x: require 'images/tips/board-basics@2x.png'
  },
  {
    title: t.l 'getting-started'
    description: t.l 'getting-started-description'
    buttonText: t.l 'check-it-out'
    url: '/guide/getting-started'
    imgUrl1x: require 'images/tips/getting-started@1x.png'
    imgUrl2x: require 'images/tips/getting-started@2x.png'
  },
  {
    title: t.l 'need-more-help'
    description: t.renderable ->
      t.div ->
        t.div -> t.a {
          href: '/guide',
          target: '_blank'
        }, -> t.l 'getting-started-guide'
        t.div ->
          t.span 'Video: '
          t.a {
            href: '/guide/trello-101',
            target: '_blank'
          }, -> t.l 'getting-started-with-trello'
        t.div -> t.a  {
          href: '/guide/create-a-team',
          target: '_blank'
        }, -> t.l 'what-are-teams'
        t.br()
        t.span -> t.format 'you-can-always-contact-support'
    buttonText: null
    url: null
    imgUrl1x: require 'images/tips/more-help@1x.png'
    imgUrl2x: require 'images/tips/more-help@2x.png'
  }
]

module.exports = class HeaderInfoHelpMenuView extends View
  viewTitleKey: 'information'
  tipIndex: 0

  events:
    'click .js-tip-help-next': ->
      clearInterval(@interval)
      @next()
    'click .js-tip-help-previous': ->
      clearInterval(@interval)
      @previous()
    'click .js-more-menu-button': 'showMoreLinks'
    'click .js-meta-page-link': 'clickMetaPage'
    'click .js-tip-help-button': 'clickTip'

  initialize: ->
    super

    @interval = setInterval =>
      @next()
    , 7000

  render: ->
    @$el.html template({ tips })
    @renderTip()
    @

  renderTip: ->
    @$('.tip-help').each (index, tipEl) =>
      if index == @tipIndex
        @$(tipEl).fadeIn()
      else
        @$(tipEl).hide()

  next: ->
    track("Header Tips", "Next")
    @tipIndex = if @tipIndex == tips.length - 1 then 0 else @tipIndex + 1
    @renderTip()

  previous: ->
    track("Header Tips", "Previous")
    @tipIndex = if @tipIndex == 0 then tips.length - 1 else @tipIndex - 1
    @renderTip()

  clickTip: (e) ->
    track("Header Tips", @tipIndex, "Clicked")

  clickMetaPage: (e) ->
    page = @$(e.currentTarget).attr('data-metapagename')
    track("Header", "Information Menu", page)

  showMoreLinks: (e) ->
    @$('.js-more-menu-button').addClass('hide')
    @$('.js-more-menu').removeClass('hide')
    track("Header", "Information Menu", "Show More Links")



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-info-help-menu-view.coffee